import "./editorialForms.css";
import { useRef } from "react";
import "./editorialForms.css";

export default function EbookForm({ data, onChange }) {
  const fileInputRef = useRef(null);
  const coverInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, ebookFile: file, ebookFileName: file.name });
    }
  };

  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({ 
          ...data, 
          coverImage: file, 
          coverImageName: file.name,
          coverImagePreview: reader.result 
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const categories = [
    "Negocios",
    "Tecnologia",
    "Marketing",
    "Autoajuda",
    "Financas",
    "Programacao",
    "Design",
    "Empreendedorismo",
    "Produtividade",
    "Saude",
    "Educacao",
    "Ficcao",
  ];

  const formats = [
    { id: "pdf", name: "PDF" },
    { id: "epub", name: "EPUB" },
    { id: "mobi", name: "MOBI" },
  ];

  const currencies = ["BRL", "USD", "EUR"];

  return (
    <div className="editorial_form ebook_form">
      <div className="editorial_form_section">
        <label>
          Arquivo do E-book <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.epub,.mobi"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.ebookFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z" />
              </svg>
              <span>{data.ebookFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, ebookFile: null, ebookFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do e-book</p>
              <span>PDF, EPUB, MOBI</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Capa do E-book <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => coverInputRef.current?.click()}>
          <input
            ref={coverInputRef}
            type="file"
            accept="image/*,.jpg,.jpeg,.png"
            onChange={handleCoverChange}
            style={{ display: "none" }}
          />
          {data?.coverImagePreview ? (
            <div className="file_selected sticker_preview">
              <img src={data.coverImagePreview} alt="Capa" style={{ maxWidth: "150px", maxHeight: "200px" }} />
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, coverImage: null, coverImageName: null, coverImagePreview: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
              </svg>
              <p>Clique para fazer upload da capa</p>
              <span>JPG, PNG</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Titulo <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Titulo do e-book"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Autor</label>
        <input
          type="text"
          placeholder="Seu nome ou pseudonimo"
          value={data?.author || ""}
          onChange={(e) => onChange({ ...data, author: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Descreva o conteudo do e-book..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={3000}
          rows={4}
        />
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Formato</label>
          <select
            value={data?.format || "pdf"}
            onChange={(e) => onChange({ ...data, format: e.target.value })}
          >
            {formats.map((fmt) => (
              <option key={fmt.id} value={fmt.id}>
                {fmt.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Numero de Paginas</label>
          <input
            type="number"
            placeholder="Ex: 120"
            value={data?.pageCount || ""}
            onChange={(e) =>
              onChange({ ...data, pageCount: parseInt(e.target.value) || 0 })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Preco</label>
        <div className="editorial_form_row">
          <select
            className="currency_select"
            value={data?.price?.currency || "BRL"}
            onChange={(e) =>
              onChange({
                ...data,
                price: { ...data?.price, currency: e.target.value },
              })
            }
          >
            {currencies.map((cur) => (
              <option key={cur} value={cur}>
                {cur}
              </option>
            ))}
          </select>
          <div className="price_input">
            <span className="currency_prefix">
              {data?.price?.currency === "BRL"
                ? "R$"
                : data?.price?.currency === "EUR"
                ? "E"
                : "$"}
            </span>
            <input
              type="number"
              step="0.01"
              placeholder="0.00"
              value={data?.price?.amount || ""}
              onChange={(e) =>
                onChange({
                  ...data,
                  price: {
                    ...data?.price,
                    amount: parseFloat(e.target.value) || 0,
                  },
                })
              }
            />
          </div>
        </div>
        <span className="editorial_form_hint">
          Deixe em branco ou 0 para gratuito
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Idioma</label>
        <select
          value={data?.language || "pt"}
          onChange={(e) => onChange({ ...data, language: e.target.value })}
        >
          <option value="pt">Portugues</option>
          <option value="en">Ingles</option>
          <option value="es">Espanhol</option>
          <option value="fr">Frances</option>
        </select>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isFree"
            checked={data?.isFree || false}
            onChange={(e) => onChange({ ...data, isFree: e.target.checked })}
          />
          <label htmlFor="isFree">E-book gratuito</label>
        </div>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="allowPreview"
            checked={data?.allowPreview !== false}
            onChange={(e) =>
              onChange({ ...data, allowPreview: e.target.checked })
            }
          />
          <label htmlFor="allowPreview">Permitir preview das primeiras paginas</label>
        </div>
      </div>

      <div className="editorial_form_tip ebook_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z" />
        </svg>
        <span>
          Publique seu e-book e alcance novos leitores. Defina preco ou
          disponibilize gratuitamente.
        </span>
      </div>
    </div>
  );
}
